// extracted by mini-css-extract-plugin
export default {"wrap":"Loading_wrap__iy43H","dot":"Loading_dot__3t9J7","cfc-loading-pulse":"Loading_cfc-loading-pulse__UX8Pp","dots":"Loading_dots__MXMUY"};